import isPropValid from '@emotion/is-prop-valid';
import * as R from 'fp-ts/Record';
export var cleanupProps = R.filterWithIndex(function (k) {
  return isPropValid(k);
});